import React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
import { Helmet } from 'react-helmet';
import 'bootstrap/dist/css/bootstrap.css';

import Header from '../header';
import Footer from './footer';
import ScreenSizeIndicator from '../screen-size-indicator';
import PageHeader from '../page-header';
import styles from './styles.css';

const { initializeGlobalSiteTag } = require('../../../lib/global-site-tag').default;

class MainLayout extends React.Component {
  static defaultProps = {
    title: '',
    noAccess: false,
  }

  static propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    noAccess: PropTypes.bool,
  }

  componentDidMount = () => {
    initializeGlobalSiteTag();
    document.body.classList.add(styles.mainLayoutBody);
  }

  render() {
    const { children, title, noAccess } = this.props;
    return (
      <>
        <div className={styles.pageWrapper}>
          <Helmet>
            <link type="text/css" rel="stylesheet" href="/client.css" />
            <link rel="shortcut icon" href="/images/favicon.ico" type="image/x-icon" />
          </Helmet>
          <Header />
          <div className={styles.pageContentBody}>
            {!!title && (
              <PageHeader title={title} />
            )}
            { !noAccess && children}
            { noAccess && (<span><div className={styles.noAccess}>Sorry, you do not have access to this page</div></span>)}
          </div>
          <ToastContainer
            position="bottom-center"
            hideProgressBar
            autoClose={5000}
            closeButton={false}
            closeOnClick
            pauseOnVisibilityChange
            draggable
            pauseOnHover
          />
          <ScreenSizeIndicator />
        </div>
        <Footer />
      </>
    );
  }
}

export default MainLayout;
